import { useEffect } from 'react';

const FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

/**
 * Keeps Tab and Shift+Tab focus inside a dialog.
 */
export const useDialogTabTrap = (dialogRef) => {
    useEffect(() => {
        const dialog = dialogRef.current;
        if (!dialog) return;

        const getFocusable = () => {
            const nodes = dialog.querySelectorAll(FOCUSABLE_SELECTOR);

            return Array.from(nodes).filter(
                (element) =>
                    element &&
                    element.offsetParent !== null &&
                    !element.hasAttribute('disabled')
            );
        };

        const onKeyDown = (event) => {
            if (event.key !== 'Tab') return;

            const focusable = getFocusable();

            if (focusable.length === 0) {
                event.preventDefault();
                dialog.focus();
                return;
            }

            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            const active = document.activeElement;

            if (event.shiftKey) {
                if (active === first || active === dialog) {
                    event.preventDefault();
                    last.focus();
                }
            } else if (active === last) {
                event.preventDefault();
                first.focus();
            }
        };

        document.addEventListener('keydown', onKeyDown);

        return () => document.removeEventListener('keydown', onKeyDown);
    }, [dialogRef]);
};
